module.exports = __webpack_public_path__ + "img/wenti_banner_pt.9a8c66fa.jpg";